import { Box, Stack, Typography } from "@mui/material"
import { EmployerFundLedger } from "../../../../models/funding/employerFundLedger"
import { SideDrawer } from "../../../shared/SideDrawer"

export const CardIssueInfoSideDrawer = ({ ledger, isOpen, setIsOpen }: { ledger: EmployerFundLedger | null, isOpen: boolean, setIsOpen: (isOpen: boolean) => void }) => {
    return (
        <SideDrawer
            title="Card Issue Info"
            open={isOpen}
            setIsOpen={setIsOpen}
        >
            <Stack spacing={3} mx={2}>
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Card Issue Type
                    </Typography>
                    <Typography variant="body1">
                        {ledger?.issueCardMetadata?.cardIssueKind}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Card Type
                    </Typography>
                    <Typography variant="body1">
                        {ledger?.issueCardMetadata?.cardOfferingType}
                    </Typography>
                </Box>
            </Stack>
        </SideDrawer>
    )
}